/**
 * DOMI-CARE - Panel Secreto de SuperAdmin (Acceso con Alt + F12 o 5 clics al logo)
 * Solicita PIN 9891, permite vincular Google Sheets, crear el usuario Propietario
 * y administrar la activación de la licencia.
 */

import { licenseState } from '../state/licenseState.js';
import { ModalManager } from './modal.js';
import { notify } from './notificationCenter.js';

let logoClickCount = 0;
let logoClickTimer = null;

export class SuperAdminManager {
  static init() {
    this.injectModals();
    this.bindKeyboardShortcut();
    this.bindLogoTouchSecret();
  }

  static bindKeyboardShortcut() {
    window.addEventListener('keydown', (e) => {
      // Atajo técnico Alt + F12
      if (e.altKey && (e.key === 'F12' || e.keyCode === 123)) {
        e.preventDefault();
        this.openPinPrompt();
      }
    });
  }

  static bindLogoTouchSecret() {
    document.addEventListener('click', (e) => {
      const logoEl = e.target.closest('.brand-logo');
      if (logoEl) {
        logoClickCount++;
        clearTimeout(logoClickTimer);
        logoClickTimer = setTimeout(() => {
          logoClickCount = 0;
        }, 2500);

        if (logoClickCount >= 5) {
          logoClickCount = 0;
          this.openPinPrompt();
        }
      }
    });
  }

  static openPinPrompt() {
    const input = document.getElementById('input-superadmin-pin');
    if (input) input.value = '';
    ModalManager.open('modal-superadmin-pin');
  }

  static openMasterPanel() {
    const lic = licenseState.getLicenseInfo();
    const isLic = licenseState.isLicensed();

    // Rellenar valores actuales
    document.getElementById('sa-url-sheets').value = lic.googleSheetUrl || '';
    document.getElementById('sa-empresa-nombre').value = lic.companyName || '';
    document.getElementById('sa-propietario-nombre').value = lic.ownerUser?.nombre || '';
    document.getElementById('sa-propietario-email').value = lic.ownerUser?.email || '';
    document.getElementById('sa-propietario-pass').value = '';
    document.getElementById('sa-nuevo-pin').value = '';

    const badgeEstado = document.getElementById('sa-badge-estado');
    if (badgeEstado) {
      badgeEstado.className = `badge ${isLic ? 'badge-success' : 'badge-warning'}`;
      badgeEstado.textContent = isLic ? 'LICENCIA OFICIAL ACTIVA' : 'MODO DEMO / EVALUACIÓN';
    }

    ModalManager.open('modal-superadmin-panel');
  }

  static injectModals() {
    // 1. Modal de Solicitud de PIN Secreto
    const pinModal = document.createElement('div');
    pinModal.id = 'modal-superadmin-pin';
    pinModal.className = 'modal-overlay';
    pinModal.innerHTML = `
      <div class="modal-container" style="max-width: 400px; text-align: center;">
        <div class="modal-header" style="justify-content: center; position: relative;">
          <h3 style="font-size: 1.05rem; font-weight: 700; color: var(--text-primary);">
            🔒 Acceso SuperAdmin
          </h3>
          <button class="btn btn-secondary btn-sm" style="position: absolute; right: 1rem;" onclick="document.getElementById('modal-superadmin-pin').classList.remove('active')">✕</button>
        </div>
        <form id="form-superadmin-pin">
          <div class="modal-body" style="padding: 1.5rem 2rem;">
            <p style="font-size: 0.85rem; color: var(--text-muted); margin-bottom: 1.25rem;">
              Ingresa el PIN de seguridad maestro para acceder a la configuración de licencia y bases de datos.
            </p>
            <div class="form-group" style="margin-bottom: 1.25rem;">
              <input type="password" id="input-superadmin-pin" class="form-control" maxlength="8" placeholder="••••" required autofocus style="text-align: center; font-size: 1.8rem; letter-spacing: 0.4em; font-family: var(--font-mono); height: 55px;">
            </div>
            <button type="submit" class="btn btn-primary" style="width: 100%; padding: 0.75rem; font-size: 0.95rem;">
              Verificar PIN
            </button>
          </div>
        </form>
      </div>
    `;
    document.body.appendChild(pinModal);

    // 2. Modal de Panel de Control Maestro SuperAdmin
    const panelModal = document.createElement('div');
    panelModal.id = 'modal-superadmin-panel';
    panelModal.className = 'modal-overlay';
    panelModal.innerHTML = `
      <div class="modal-container" style="max-width: 780px;">
        <div class="modal-header">
          <div style="display: flex; align-items: center; gap: 0.75rem;">
            <h2 style="font-size: 1.2rem; font-weight: 800; color: var(--text-primary);">
              🛠️ Panel Maestro SuperAdmin y Activación Comercial
            </h2>
            <span id="sa-badge-estado" class="badge badge-warning">MODO DEMO</span>
          </div>
          <button class="btn btn-secondary btn-sm" onclick="document.getElementById('modal-superadmin-panel').classList.remove('active')">✕</button>
        </div>
        <form id="form-superadmin-activate">
          <div class="modal-body" style="display: flex; flex-direction: column; gap: 1.25rem;">
            
            <!-- SECCIÓN 1: VINCULACIÓN CON GOOGLE SHEETS -->
            <div style="background: var(--slate-50); padding: 1rem; border-radius: var(--radius-md); border: 1px solid var(--border-medium);">
              <h4 style="font-size: 0.9rem; font-weight: 700; color: var(--primary-800); margin-bottom: 0.5rem;">
                1. Conexión a la Base de Datos Google Sheets (Apps Script Web App)
              </h4>
              <p style="font-size: 0.8rem; color: var(--text-muted); margin-bottom: 0.75rem;">
                Pega la URL de producción generada en Apps Script al implementar <code>Code.gs</code>.
              </p>
              <input type="url" id="sa-url-sheets" class="form-control" placeholder="https://script.google.com/macros/s/AKfycb.../exec" required>
            </div>

            <!-- SECCIÓN 2: ALTA DEL PROPIETARIO / DIRECTOR -->
            <div style="background: #ffffff; padding: 1rem; border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
              <h4 style="font-size: 0.9rem; font-weight: 700; color: var(--teal-700); margin-bottom: 0.5rem;">
                2. Datos de Entrega y Alta del Usuario Propietario
              </h4>
              <p style="font-size: 0.8rem; color: var(--text-muted); margin-bottom: 0.75rem;">
                El propietario recibirá esta cuenta como Director General con control completo del sistema.
              </p>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Nombre de la Empresa / Clínica *</label>
                  <input type="text" id="sa-empresa-nombre" class="form-control" placeholder="Ej: Sanitas Internación Domiciliaria" required>
                </div>
                <div class="form-group">
                  <label class="form-label">Nombre y Apellido del Propietario *</label>
                  <input type="text" id="sa-propietario-nombre" class="form-control" placeholder="Ej: Dr. Gustavo Albarracín" required>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Email Oficial de Acceso *</label>
                  <input type="email" id="sa-propietario-email" class="form-control" placeholder="director@clinica.com" required>
                </div>
                <div class="form-group">
                  <label class="form-label">Contraseña de Inicio *</label>
                  <input type="password" id="sa-propietario-pass" class="form-control" placeholder="Clave asignada al propietario" required>
                </div>
              </div>
            </div>

            <!-- SECCIÓN 3: MIGRACIÓN DE DATOS -->
            <div style="background: var(--slate-50); padding: 0.85rem; border-radius: var(--radius-md); border: 1px solid var(--border-subtle);">
              <label class="switch-label">
                <input type="checkbox" id="sa-check-migrate" class="switch-input" checked>
                <span style="font-weight: 600; font-size: 0.85rem;">
                  Conservar y migrar los pacientes y visitas registrados en la demo hacia la nueva hoja de Google Sheets.
                </span>
              </label>
            </div>

            <!-- SECCIÓN 4: CAMBIO DE PIN SUPERADMIN -->
            <div style="border-top: 1px solid var(--border-subtle); padding-top: 0.75rem;">
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.3rem;">
                <label class="form-label" style="color: var(--text-muted);">Modificar PIN Maestro SuperAdmin (Opcional)</label>
                <span style="font-size: 0.75rem; color: var(--text-muted);">PIN inicial de fábrica: <strong>9891</strong></span>
              </div>
              <input type="text" id="sa-nuevo-pin" class="form-control" placeholder="Ingresa nuevo PIN de 4 dígitos si deseas cambiarlo">
            </div>

          </div>
          <div class="modal-footer" style="justify-content: space-between;">
            <button type="button" id="btn-sa-reset-demo" class="btn btn-secondary btn-sm" style="color: var(--danger-600);">
              ↺ Volver a Modo Demo
            </button>
            <div style="display: flex; gap: 0.75rem;">
              <button type="button" class="btn btn-secondary" onclick="document.getElementById('modal-superadmin-panel').classList.remove('active')">Cerrar</button>
              <button type="submit" class="btn btn-primary">
                🚀 Activar Sistema Oficial y Entregar al Propietario
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  `;
  document.body.appendChild(panelModal);

  // Bind Submit Event for PIN
  document.getElementById('form-superadmin-pin').addEventListener('submit', (e) => {
    e.preventDefault();
    const pin = document.getElementById('input-superadmin-pin').value;
    if (licenseState.verifyPin(pin)) {
      ModalManager.close('modal-superadmin-pin');
      notify.success('Identidad SuperAdmin verificada correctamente.');
      this.openMasterPanel();
    } else {
      notify.danger('PIN incorrecto. Acceso restringido.');
      document.getElementById('input-superadmin-pin').value = '';
    }
  });

  // Bind Submit Event for Activation
  document.getElementById('form-superadmin-activate').addEventListener('submit', async (e) => {
    e.preventDefault();
    try {
      const url = document.getElementById('sa-url-sheets').value;
      const empresa = document.getElementById('sa-empresa-nombre').value;
      const propNombre = document.getElementById('sa-propietario-nombre').value;
      const propEmail = document.getElementById('sa-propietario-email').value;
      const propPass = document.getElementById('sa-propietario-pass').value;
      const migrate = document.getElementById('sa-check-migrate').checked;
      const nuevoPin = document.getElementById('sa-nuevo-pin').value;

      // Si especificó nuevo PIN, cambiarlo
      if (nuevoPin && nuevoPin.trim()) {
        licenseState.changePin(nuevoPin);
        notify.info(`Nuevo PIN SuperAdmin actualizado: ${nuevoPin.trim()}`);
      }

      await licenseState.activateLicense({
        googleSheetUrl: url,
        companyName: empresa,
        ownerName: propNombre,
        ownerEmail: propEmail,
        ownerPassword: propPass,
        migrateData: migrate
      });

      ModalManager.close('modal-superadmin-panel');
      notify.success(`¡Sistema Oficial DOMI-CARE activado con éxito para ${empresa}! Usuario ${propNombre} listo para operar.`);
    } catch (err) {
      notify.danger(`Error de activación: ${err.message}`);
    }
  });

  // Reset to Demo button
  document.getElementById('btn-sa-reset-demo').addEventListener('click', async () => {
    if (confirm('¿Deseas desvincular Google Sheets y regresar la aplicación al Modo Demo de Evaluación?')) {
      await licenseState.resetToDemo();
      ModalManager.close('modal-superadmin-panel');
      notify.warning('Aplicación restablecida a Modo Demo de Evaluación.');
    }
  });
}
}
